"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedButton = void 0;
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("@mui/material/Button"));
exports.ThemedButton = (0, styles_1.styled)(Button_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        boxSizing: 'border-box',
        fontWeight: 500,
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '0.4rem',
        fontSize: '1.6rem',
        padding: '1.6rem 2.8rem',
        maxHeight: '4.8rem',
        border: '2px solid',
        boxShadow: 'none',
        '&:hover': {
            border: '2px solid',
            boxShadow: 'none',
        },
        '&.MuiButton-sizeSmall': {
            fontSize: '1.4rem',
            padding: '1.2rem 2.0rem',
            maxHeight: '3.8rem',
        },
        '&.MuiButton-sizeMedium': {
            fontSize: '1.6rem',
            padding: '1.6rem 2.8rem',
            maxHeight: '4.8rem',
        },
        '&.MuiButton-containedPrimary': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            '&:hover': {
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary[600],
                backgroundColor: 'transparent',
            },
        },
        '&.MuiButton-containedSecondary': {
            borderColor: theme.palette.secondary.main,
            color: theme.palette.primary[600],
            '&:hover': {
                borderColor: theme.palette.secondary.main,
                color: theme.palette.primary[600],
                backgroundColor: 'transparent',
            },
        },
        '&.MuiButton-outlinedPrimary': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary[600],
            '&:hover': {
                borderColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
            },
        },
        '&.MuiButton-outlinedSecondary': {
            borderColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.primary[600],
            },
        },
        '&.MuiButton-text': {
            borderColor: 'transparent',
            '&:hover': {
                backgroundColor: 'transparent',
                color: theme.palette.primary[600],
            },
        },
        '&.Mui-disabled': {
            border: '2px solid',
            backgroundColor: theme.palette.primary[200],
            borderColor: theme.palette.primary[200],
            color: theme.palette.primary[400],
        },
    });
});
